import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsVI: CultureInfo = {
  name: 'es-VI',
  displayName: 'español (Islas Vírgenes de EE. UU.)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-VI',
  parent: CultureInfoEs
};
